export default __webpack_public_path__ + "assets/6bhiG.mp3";